import { useEffect, useState } from "react";
import { Form } from "../../common/Form";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { CommonDialog } from "../../common/CommonDialog";
import { jwordValignOptions } from "./jword-config";
import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";

export function ImageDialog({imageProps,visible,onOK,onCancel})
{    
    const {t} = useTranslation();     
    const [imageInfo,setImageInfo]=useState({});

    const onChange=(formData)=>{
        if(formData.fixRatio)
            formData = onAdjustAspect(formData,formData.imageWidth != imageInfo.imageWidth,formData.imageHeight != imageInfo.imageHeight)
        setImageInfo(formData);
    };
    const _onCancel=()=>{
        onCancel();
    };
    const _onOK=()=>{
        onOK({width:imageInfo.imageWidth,height:imageInfo.imageHeight,align:imageInfo.vAlign});
    };
    const onResetSize=()=>{
        var ii={...imageInfo};
        ii.imageWidth = imageInfo.orgWidth;
        ii.imageHeight = imageInfo.orgHeight;
        setImageInfo(ii);
    };
    const onAdjustAspect=(formData,widthChange,heightChange)=>{
        var w = formData.imageWidth;
        var h = formData.imageHeight;
        var ow = imageInfo.orgWidth;
        var oh = imageInfo.orgHeight;
        if(heightChange || !widthChange)
        {
            w = Math.round(h * 100.0 * (ow/oh))/100.0;
            formData.imageWidth = w;
        }
        else
        {
            h = Math.round(w * 100.0 * (oh/ow))/100.0;
            formData.imageHeight = h;
        }
        return formData;
    };
    const valignOptions=()=>{
        return jwordValignOptions.map((opt)=>{return {label:t('Editor.valign.'+opt),value:opt}});
    }
    useEffect(()=>{
        console.log("imageProps:"+JSON.stringify(imageProps));
        setImageInfo({...imageProps});
    },[imageProps]);
    return(
        <>
        <CommonDialog header={t('Editor.Image_Settings')} visible={visible} onOK={_onOK} onCancel={_onCancel}>
            <div className="p-2" style={{maxWidth:'400px'}}>
            <Form key="formatImage1" id="formatImage1" formData={imageInfo} columns="1" onChange={onChange}
                fields={[
                    {id:"vAlign",ftype:"dropdown",field:"vAlign",label:t('Editor.Vertical_Alignment'),options:valignOptions()}
                ]}>
            </Form>	
            <Panel header={t('Editor.Size')}>
                <Form key="formatImage2" id="formatImage2" formData={imageInfo} columns="2" onChange={onChange}
                    fields={[
                        {id:"imageWidth",ftype:"number",field:"imageWidth",label:t('Editor.Width')},
                        {id:"imageHeight",ftype:"number",field:"imageHeight",label:t('Editor.Height')},
                        {id:"fixRatio",ftype:"checkbox",field:"fixRatio",label:t('Editor.Fix_aspect_ratio')}
                    ]}>
                </Form>	
                <div className="mt-2">
                    <Button severity="secondary" size="small" label={t('Editor.Reset_size')} onClick={onResetSize}></Button>
                </div>
            </Panel>
            </div>
        </CommonDialog>
        </>
    );
}